import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { inputCls, btnPrimary, dialogCls, errMsg } from "./shared";

const EMPTY = { name: "", gender: "", contact: "", location: "", description: "" };

export function RequestDialog({ business, onClose }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/market/requests", { ...f, business_id: business.business_id });
      toast.success(`Request sent to ${business.name}`);
      setF(EMPTY);
      onClose();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!business} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className={dialogCls} data-testid="request-dialog">
        <DialogHeader><DialogTitle className="font-heading text-sky-950">Request from {business?.name}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="request-name" className={inputCls} placeholder="Your name" value={f.name} onChange={set("name")} required />
          <select data-testid="request-gender" className={inputCls} value={f.gender} onChange={set("gender")} required>
            <option value="">Gender</option><option>Male</option><option>Female</option><option>Other</option>
          </select>
          <input data-testid="request-contact" className={inputCls} placeholder="WhatsApp / phone with country code" value={f.contact} onChange={set("contact")} required />
          <input data-testid="request-location" className={inputCls} placeholder="Your location" value={f.location} onChange={set("location")} required />
          <textarea data-testid="request-description" className={`${inputCls} h-28 py-2`} placeholder="Describe the service(s) or item(s) you need" value={f.description} onChange={set("description")} required />
          <button data-testid="request-submit" type="submit" className={`${btnPrimary} w-full`} disabled={busy}>
            {busy ? "Sending…" : "Submit request"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
